import { FC, ReactNode } from 'react';
import { Box, Grid, Paper, Typography, Divider } from '@mui/material';

export interface FormSectionProps {
    title?: string;
    description?: string;
    children: ReactNode;
    columns?: 1 | 2 | 3 | 4;
    spacing?: number;
    elevation?: number;
    noPadding?: boolean;
}

export const FormSection: FC<FormSectionProps> = ({
    title,
    description,
    children,
    columns = 1,
    spacing = 3,
    elevation = 0,
    noPadding = false,
}) => {
    const gridColumns = {
        1: 12,
        2: 6,
        3: 4,
        4: 3,
    };

    return (
        <Paper
            elevation={elevation}
            sx={{
                p: noPadding ? 0 : 3,
                mb: 3,
                borderRadius: 2,
            }}
        >
            {(title || description) && (
                <Box sx={{ mb: 3 }}>
                    {title && (
                        <Typography
                            variant="h6"
                            sx={{
                                fontWeight: 600,
                                mb: description ? 1 : 0,
                            }}
                        >
                            {title}
                        </Typography>
                    )}
                    {description && (
                        <Typography variant="body2" color="text.secondary">
                            {description}
                        </Typography>
                    )}
                    <Divider sx={{ mt: 2 }} />
                </Box>
            )}

            <Grid container spacing={spacing}>
                {Array.isArray(children)
                    ? children.map((child, index) => (
                          <Grid
                              item
                              key={index}
                              xs={12}
                              sm={columns >= 2 ? gridColumns[columns] : 12}
                              md={gridColumns[columns]}
                          >
                              {child}
                          </Grid>
                      ))
                    : children}
            </Grid>
        </Paper>
    );
};

